<template>
  <video
    v-if="!preview"
    controls="controls"
    autoplay="autoplay"
    muted="muted"
    width="100%"
    height="100%"
    :key="conf.componentId"
    :class="'tmVideo' + conf.componentId"
    :style="{
      objectFit: 'fill',
      borderRadius: conf.borderRadius + '%',
      'pointer-events': 'none'
    }"
    :src="conf.videoList[0].url"
  />
  <video
    v-else
    autoplay="autoplay"
    muted="muted"
    width="100%"
    height="100%"
    :key="conf.componentId"
    :class="'tmVideo' + conf.componentId"
    :style="{
      objectFit: 'fill',
      borderRadius: conf.borderRadius + '%'
    }"
    :src="conf.videoList[0].url"
  />
</template>

<script>
export default {
  name: 'TumengVideo',
  props: {
    conf: {
      type: Object,
      default: () => {}
    },
    preview: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      video: undefined,
      idx: 0
    }
  },
  mounted() {
    this.video = document.getElementsByClassName(
      'tmVideo' + this.conf.componentId
    )[0]

    const play = () => {
      this.idx += 1
      if (this.idx === this.conf.videoList.length) {
        this.idx = 0
      }
      this.video.src = this.conf.videoList[this.idx].url
      this.video.load()
      const playPromise = this.video.play()
      if (playPromise !== undefined) {
        playPromise
          .then(_ => {
            // Automatic playback started!
            // Show playing UI.
          })
          .catch(_ => {
            // Auto-play was prevented
            // Show paused UI.
          })
      }
    }

    this.video.addEventListener('ended', play)
  }
}
</script>
